import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ForSaleConfiguration, LineItemTypes, ShirtConfiguration } from '../../LineItems/LineItemTypes/LineItemTypes';
import { cartSizeEventListener, getCart, getCartSize } from '../../../utils/kit/modules/shoppingCart';

interface ShoppingCartProps
{

}

const ShoppingCart = (props: ShoppingCartProps) =>
{
    const navigate = useNavigate();

    const [cartSize, setCartSize] = React.useState<number>(0);

    const cartLength = cartSize ? cartSize.toString() : '0';

    /**
     * Effect that enables an Event Listener to handle cart size changes.
     */
    React.useEffect(() => {
        const handleCartSizeChange = (event?: Event) => 
        {
            setCartSize(getCartSize());
        }

        handleCartSizeChange();

        return cartSizeEventListener(handleCartSizeChange);
        
    }, []);

    return(<div className='shoppingCartContainer'>
        <img className='shoppingCartIcon' src='/assets/img/shoppingCart.svg' onClick={() => navigate('/checkout')}/>
        {cartLength !== '0' &&<div className="shoppingCartCircle" onClick={() => navigate('/checkout')}>{cartLength}</div>}
    </div>);
}

export default ShoppingCart;
